<template>
  <div>
    <div class="listSummary">
      <div class="checkbox">
        <input type="checkbox" name="" id="all_channel" v-model="chkAll">
        <label for="all_channel">{{locale.all}}</label>
      </div>
      <span v-if="chkChannel.length > 0" class="chkCnt">{{`${locale.select} ${chkChannel.length} / ${channel.length}`}}</span>
      <button type="button" class="btn sizeXs btnRed btnReset" @click="delChannel" :disabled="chkChannel.length === 0">{{locale.delete}}</button>
      <p class="cnt">
        {{locale.all}} <span class="colorPrimary f_medium">{{channel.length}}</span> / {{list.length}}
      </p>
    </div>
    <div class="chList">
      <ChannelCreate
        :locale="locale"
        :genre="genre"
        :lang="lang" />
      <ChannelItem v-for="item in channel"
        :key="item.id"
        :item="item"
        :locale="locale"
        :genre="genre"
        :lang="lang" />
    </div>
  </div>
</template>

<script>
import ChannelItem from '@/components/Tv/Item.vue'
import ChannelCreate from '@/components/Tv/Create.vue'

export default {
  props: [
    'locale',
    'list',
    'genre',
    'lang'
  ],
  components: {
    ChannelItem,
    ChannelCreate
  },
  computed: {
    listView () {
      return this.$store.state.tv.listView
    },
    getFilter () {
      return this.$store.getters['tv/getFilter']
    },
    channel () {
      const { word = '', genre = [], lang = [] } = this.getFilter || {}

      const normalize = (value) => {
        return String(value || '')
          .toLowerCase()
          .replace(/\s+/g, '')
          .trim()
      }

      const keyword = normalize(word)
      let list = this.list || []

      if (keyword) {
        list = list.filter((x) => {
          const name = normalize(x.name)
          const no = normalize(x.no)
          const itemGenre = normalize(x.genre)
          const itemLang = normalize(x.lang)

          return (
            name.includes(keyword) ||
            no.includes(keyword) ||
            itemGenre.includes(keyword) ||
            itemLang.includes(keyword)
          )
        })
      }

      if (genre.length) {
        const genreSet = genre.map(normalize)
        list = list.filter(x => genreSet.includes(normalize(x.genre)))
      }

      if (lang.length) {
        const langSet = lang.map(normalize)
        list = list.filter(x => langSet.includes(normalize(x.lang)))
      }

      return list
    },
    unLang () {
      const lang = this.getFilter.lang
      return this.list.filter(x => !lang.includes(x.lang))
    },
    chkChannel () {
      return this.channel.filter(x => x.checked).map(x => x.id)
    }
  },
  watch: {
    chkAll (isChkAll) {
      this.$store.commit('tv/chkAllChannel', isChkAll)
    }
  },
  data () {
    return {
      chkAll: false
    }
  },
  methods: {
    delChannel () {
      if (window.confirm(this.locale.confirm_channel_delete_all)) {
        const delIds = this.chkChannel
        const list = this.channel.filter(x => !delIds.includes(x.id))
        this.$store.commit('onLoading', true)
        this.$store.dispatch('tv/setChannel', list).then(() => {
          this.$store.dispatch('tv/getChData').then(() => {
            alert(this.locale.complete_delete)
            this.$store.commit('onLoading', false)
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.listSummary {
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;
}
.cnt {
  margin-left: auto;
}
.noData {
  padding: 120px 30px 200px;
  text-align: center;
  font-size: 1.2em;
  &:before {
    content: "";
    display: block;
    height: 64px;
    margin-bottom: 30px;
    background: url('~@/assets/img/ico_search.svg') 50% 50% / contain no-repeat;
    opacity: 0.2;
  }
}
.chkCnt {
  margin-right: 0.5em;
}
.btnReset[disabled] {
  opacity: 0.5;
}
</style>
